import { useCallManager } from 'contexts/call_manager_context'
import React from 'react'

import { css } from 'design'
import { cn } from 'util/cn'

import { useParticipantManager } from '../../../contexts/participant_manager_context'
import { CallStartIcon } from '../../../images'
import { pulseKeyframes } from './shared_styles'

export const ActiveCallBanner = ({
  className,
  ...props
}: React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>) => {
  const {
    activeCall: { navToVideoView },
  } = useCallManager()

  const { isVideoActive } = useParticipantManager()

  const label = isVideoActive ? 'Return to Video Call' : 'Return to Call'
  return (
    <button
      {...props}
      className={cn(activeCallBannerStyles(), className)}
      aria-label={label}
      onClick={navToVideoView}
    >
      <CallStartIcon />
      <span>{label}</span>
    </button>
  )
}

export const activeCallBannerStyles = css({
  width: '100%',
  height: '$space$7',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fill: 'white',
  border: 0,
  outline: 0,
  fontSize: '$3',
  fontWeight: '600',
  background: 'none',
  position: 'relative',
  cursor: 'pointer',

  '> * + *': {
    marginLeft: '$2',
  },

  '&::after': {
    content: '""',
    width: '100%',
    height: '100%',
    position: 'absolute',
    inset: 0,
    backgroundColor: '$successMedium',
    // Pulsing animation
    animation: `${pulseKeyframes} 4s infinite`,
    zIndex: -1,
  },
})
